module.exports = __webpack_public_path__ + "static/media/logo_without_alpha.4f109ca6.svg";